import { CustomQuickLink, QuickLinkViewItem } from '../models';

export const mapCustomQuickLinksToQuickLinkViewItems = (
  customQuickLinks: CustomQuickLink[],
  hiddenQuickLinkIds: string[],
): QuickLinkViewItem[] =>
  customQuickLinks.map((link) => {
    return {
      ...link,
      active: !hiddenQuickLinkIds.includes(link.id),
    };
  });
